import party from '../views/party'

export default {
  path: '/party',
  component: party,
  redirect: '/party/member',
  name: 'Party',
  meta: { title: '商城管理' },
  children: [
    {
      path: '/party/member',
      component: () => import('@/views/party/Member'),
      name: 'Member',
      meta: { title: '分类管理' }
    },
    {
      path: '/party/goods',
      component: () => import('@/views/party/Goods'),
      name: 'Goods',
      meta: { title: '产品管理' }
    },
    {
      path: '/party/goodsmx',
      component: () => import('@/views/party/Goodsmx'),
      name: 'Goods',
      meta: { title: '产品明细' }
    },
    {
      path: '/party/notice',
      component: () => import('@/views/party/Notice'),
      name: 'Notice',
      meta: { title: '轮播图管理' }
    },
    {
      path: '/party/fenqu',
      component: () => import('@/views/party/fenqu'),
      name: 'fenqu',
      meta: { title: '分区管理' }
    }
  ]
}
